var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'user.profile' }}},[_c('picture',{staticClass:"pl-3 pr-3"},[_c('img',{staticClass:"rounded-circle img-fluid",staticStyle:{"width":"2.5em","height":"2.5em"},attrs:{"src":_vm.avatarUser,"alt":"profile img"}}),_vm._v(" "),_c('span',{staticClass:"profile-alias"},[_vm._v(_vm._s(_vm.user.apelido))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb2787f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
// module id = 458
// module chunks = 1